module.exports = require("./bs-Cyrl.js");